import React from "react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StaggerGroup, StaggerItem, Reveal } from "@/components/shared/Reveal";
import { WHY_CHOOSE, IMAGES } from "@/data/site";

export const WhyChooseUs = () => {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="why-choose">
      <div className="container-x">
        <SectionHeading
          align="center"
          className="mb-16"
          eyebrow="Why choose us"
          title="Built on trust, engineered for reliability."
          description="Seven reasons thousands of families and businesses hand us the things that matter most."
        />

        <div className="grid lg:grid-cols-12 gap-6">
          {/* Feature image block */}
          <Reveal className="lg:col-span-4 lg:row-span-2 rounded-3xl overflow-hidden relative min-h-[300px] shadow-card">
            <img src={IMAGES.delivery} alt="Delivery professional" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand via-brand/40 to-transparent" />
            <div className="absolute bottom-0 p-8 text-white">
              <p className="font-heading font-bold text-2xl leading-tight">Your goods, handled like our own.</p>
              <p className="mt-2 text-white/80 text-sm">Trained crews, insured transit, zero compromises.</p>
            </div>
          </Reveal>

          <StaggerGroup className="lg:col-span-8 grid sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {WHY_CHOOSE.map(({ icon: Icon, title, desc }) => (
              <StaggerItem key={title} className="h-full">
                <div
                  className="group h-full rounded-3xl border border-gray-100 bg-surface p-7 transition-transform duration-300 hover:-translate-y-1.5 hover:bg-white hover:shadow-card"
                  data-testid={`why-card-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                >
                  <Icon className="h-8 w-8 text-brand-accent transition-transform duration-300 group-hover:scale-110" />
                  <h3 className="mt-5 font-heading font-bold text-lg text-ink">{title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{desc}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </div>
    </section>
  );
};
